// extracted by mini-css-extract-plugin
export default {"card-list":"Ii0Qr","container":"UGP6E","main":"loe2x","icon":"YOqOd","title":"pZSDx"};